import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './CheckEmailPage.css';

const CheckEmailPage = () => {
  const [searchParams] = useSearchParams();
  const email = useMemo(() => searchParams.get('email') || '', [searchParams]);

  return (
    <div className="check-email-page">
      <div className="check-email-card">
        <div className="email-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="20" width="60" height="40" rx="4" fill="none" stroke="#1f5d5b" strokeWidth="2" />
            <path d="M10 20L40 45L70 20" stroke="#1f5d5b" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <h1 className="check-email-title">Vérifiez votre boîte mail</h1>

        <p className="check-email-message">
          Un lien de connexion a été envoyé à <strong>{email}</strong>
        </p>

        <div className="email-badge">
          Le lien expire dans 15 minutes
        </div>

        <p className="spam-notice">
          Pensez à vérifier vos <strong>spams</strong> si vous ne trouvez pas l'email.
        </p>

        <Link to="/members" className="back-link">Retour à la connexion</Link>
      </div>
    </div>
  );
};

export default CheckEmailPage;
